// extracted by css-extract-rspack-plugin
module.exports =  {"week-label":"WeekLabel-EROs__week-label","week-number":"WeekLabel-MLJW__week-number","week-name":"WeekLabel-w7rj__week-name"};